// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Fechamentos_ResumoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /fechamentos/resumo
 *
 * GET /fechamentos/resumo/{id}
 *
 * Returns summary statistics for a fechamento
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Fechamentos_ResumoResponseDados {
meta_faturamento: number
meta_clientes: number
total_previsto: number
total_efetivo: number
valor_realizado: number
variacao_percentual: number
total_despesas: number
lucro_liquido: number
status: string
periodo: string
}

export type Fechamentos_ResumoResponse = ApiResponse<Fechamentos_ResumoResponseDados>;

registerResponseContract('Fechamentos_ResumoResponse', {
  meta_faturamento:    { type: 'number',  required: true },
  meta_clientes:       { type: 'number',  required: false },
  total_previsto:      { type: 'number',  required: true },
  total_efetivo:       { type: 'number',  required: true },
  valor_realizado:     { type: 'number',  required: true },
  variacao_percentual: { type: 'number',  required: false },
  total_despesas:      { type: 'number',  required: true },
  lucro_liquido:       { type: 'number',  required: true },
  status:              { type: 'string',  required: true },
  periodo:             { type: 'string',  required: true },
})
